// เดิมแต่ละไฟล์มี isFilledObjectArray / hasScoreOrderError ของตัวเอง โดย "ไม่เหมือนกันเป๊ะ"
// จึงแยกเป็นคนละฟังก์ชันชัดเจน ห้ามรวมเป็นอันเดียวเพราะ logic เงื่อนไขต่างกันจริง

// ---- ใช้ใน EvaluateForm (Insert) กับ `groups` ----
// เช็คทุก field ยกเว้น weight (ถ้า weight ว่าง -> ผ่าน, ถ้า weight มีค่า -> field อื่นทั้งหมดต้องไม่ว่าง)
export function isFilledObjectArrayInsert(arr) {
  return arr.every(obj => {
    const { weight, ...rest } = obj;
    if (weight === "" || weight === null || weight === undefined) {
      return true;
    }
    return Object.values(rest).every(val => {
      if (Array.isArray(val)) {
        return val.every(v => v !== "" && v !== null && v !== undefined);
      }
      return val !== "" && val !== null && val !== undefined;
    });
  });
}

// ---- ใช้ใน EditEvaluateForm (Edit) กับ `EditGroup` ----
// เช็คเฉพาะ score กับ scores (ไม่เช็ค field อื่น เช่น file_data/no/evaluate_salary_result_id)
export function isFilledObjectArrayEdit(arr) {
  if (!Array.isArray(arr)) return false;

  return arr.every(obj => {
    if (!obj || typeof obj !== "object") return false;

    const { weight, score, scores } = obj;

    if (weight === "" || weight === null || weight === undefined) {
      return true;
    }

    const isScoreValid = score !== "" && score !== null && score !== undefined;

    const isScoresValid =
      Array.isArray(scores) &&
      scores.length > 0 &&
      scores.every(v => v !== "" && v !== null && v !== undefined);

    return isScoreValid && isScoresValid;
  });
}

// ---- ใช้ใน EvaluateForm (Insert) กับ `groups` ----
// เปรียบเทียบ score ดิบ ไม่แปลงเป็น Number
export function hasScoreOrderErrorInsert(groups) {
  return groups.some(group =>
    group.scores.some((score, idx) => {
      if (idx === 0) return false;
      const prevValue = group.scores[idx - 1] ?? 0;
      return score <= prevValue && score > 0;
    })
  );
}

// ---- ใช้ใน EditEvaluateForm (Edit) กับ `EditGroup` ----
// แปลงเป็น Number ก่อนเปรียบเทียบ + guard กรณี EditGroup ยังเป็น null
export function hasScoreOrderErrorEdit(editGroup) {
  if (!Array.isArray(editGroup)) return false;
  return editGroup.some(group =>
    group.scores.some((score, idx) => {
      if (idx === 0) return false;
      const current = Number(score);
      const prevValue = Number(group.scores[idx - 1] ?? 0);
      return current <= prevValue && current > 0;
    })
  );
}

export const submitErrorMessage = {
  evaluateResultCompletely: "แบบประเมินผลสัมฤทธิ์ของงาน: กรุณากรอกข้อมูลตัวชี้วัดให้ครบถ้วน",
  evaluateResultPercentage: "แบบประเมินผลสัมฤทธิ์ของงาน: กรุณากรอกน้ำหนักร้อยละ (ข) ให้ผลรวมเท่ากับ 100",
  targetLevalScoresOrder: "แบบประเมินผลสัมฤทธิ์ของงาน: คะแนนแต่ละระดับต้องไม่น้อยกว่าระดับก่อนหน้า กรุณาตรวจสอบ",

  evaluateBehaviorCompletely: "แบบประเมินพฤติกรรมการปฏิบัติราชการหรือสมรรถนะ: กรุณากรอกคะแนนให้ครบทุกรายการ",

  behaviorLoadFailed:
    "โหลดคะแนนพฤติกรรมการปฏิบัติราชการ (องค์ประกอบที่ 2) ไม่สำเร็จ จึงไม่สามารถบันทึกได้ เพราะคะแนนจะถูกบันทึกเป็น 0 ทับของเดิม กรุณารีเฟรชหน้านี้ใหม่อีกครั้ง",

  evaluateDevelopmentCompletely: "แผนพัฒนาการปฏิบัติราชการรายบุคคล: กรุณากรอกหัวข้อและรายละเอียดการพัฒนาอย่างน้อย 1 รายการ",
}